export default "__VITE_ASSET__CrEmm9k4__"